/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";

import styled from "styled-components";

import { ImageBlock } from "src/classes/block/block-types";
import { TD } from "src/components/DrilledView/SidePanel/Sections/Attributes";
import { ViennaTag } from "src/components/DrilledView/SidePanel/Sections/ViennaTag";

interface Props {
  block: ImageBlock;
}
export function ImageAttributes({ block }: Props) {
  const tags = block.observe((state) => state.tags);
  return (
    <tr>
      <TD isFirstColumn>&lt;tags&gt;</TD>
      <TD>
        <TagsWrapper>
          {tags.map((tag, index: number) => (
            <ViennaTag key={index} tag={tag.tag} removeTag={() => {}} editable={false} />
          ))}
        </TagsWrapper>
      </TD>
    </tr>
  );
}

const TagsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;
